import React from "react";
import { createStandaloneToast } from "@chakra-ui/react";
import { theme } from "@simplified-workspace/shared/util-theme";
import Toast from "../_components/common/Toast";

const toast = createStandaloneToast({ theme });

export function showToast(props) {
  return toast({
    ...props,
    position: props?.position ? props.position : "top-right",
    containerStyle: {
      marginTop: "1rem",
      marginRight: "1rem",
    },
    render: ({ onClose }) => (
      <Toast
        status={props.status}
        title={props.title}
        description={props.description}
        onClose={onClose}
      />
    ),
  });
}
